import React, { FC } from 'react';
import AppRouter from 'AppRouter';
import { ApplicationDataProvider } from './contexts/ApplicationDataContext';
import { UserProvider } from './contexts/UserContext';

const App: FC = () => {
  return (
    <UserProvider>
      <ApplicationDataProvider>
        <AppRouter />
      </ApplicationDataProvider>
    </UserProvider>
  );
}

export default App;
